import { Add } from '@mui/icons-material';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Actions, Subjects } from '../../services/ability';
import ActionsBar from '../ActionsBar/ActionsBar';
import Permission from '../Permission';
import styles from './SurveyRecordsActions.module.scss';

export default function SurveyRecordsActions() {
    const navigate = useNavigate()
    return (
        <ActionsBar>
            <Grid container justifyContent="flex-between" alignItems="center" className={styles.Wrapper}>
                <Grid item xs={6} container alignContent="center">
                    <Typography variant="h3" color="primary">Visitas</Typography>
                </Grid>
                <Grid item xs={6} container justifyContent="flex-end">
                    <Permission action={Actions.CREATE} subject={Subjects.SURVEYRECORD}>
                        <Tooltip title="Criar visita">
                            <IconButton onClick={() => navigate("/create-survey-record")}>
                                <Add />
                            </IconButton>
                        </Tooltip>
                    </Permission>
                </Grid>
            </Grid>
        </ActionsBar>
    )
}
